import ContactInfo from './contactInfo'

export default ContactInfo